import { render, staticRenderFns } from "./StudentReview.vue?vue&type=template&id=4ae2fda7&"
import script from "./StudentReview.vue?vue&type=script&lang=js&"
export * from "./StudentReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports